import classNames from 'classnames'
import React from 'react'

export const GridTable: React.FC<{
  className?: string
  children: React.ReactNode
}> = ({ children, className }) => {
  return (
    <div className={classNames('grid grid-cols-4 gap-2', className)}>
      {children}
    </div>
  )
}
